export default function setupMap() {
    const element = document.querySelector('#mapccdc');
    const POPUP_HTML = '<span class="map_text" style="font-size:11px;"><b style="white-space:nowrap;">Coleman Country Day Camp</b><br>55 Babylon Turnpike<br>Merrick, NY 11566<br><a href="https://www.google.com/maps/preview#!data=!1m4!1m3!1d4977!2d-73.5733734!3d40.6668987!4m36!3m16!1m0!1m5!1sColeman+Country+Day+Camp%2C+55+Babylon+Turnpike%2C+Freeport%2C+NY+11520!2s0x89c27c04a94167ed%3A0x48de76d8b5d5a535!3m2!3d40.666859!4d-73.573447!3m8!1m3!1d4977!2d-73.5733734!3d40.6668987!3m2!1i1267!2i1263!4f13.1!5m16!2m15!1m14!1s0x0%3A0x48de76d8b5d5a535!2sColeman+Country+Day+Camp!3m8!1m3!1d4977!2d-73.5733734!3d40.6668987!3m2!1i1267!2i1263!4f13.1!4m2!3d40.6668599!4d-73.5734466!7m1!3b1&fid=0" target="_blank" style="font-size:11px;">Get Directions</a><br><br></span>';
    if (element) {
        const map = new google.maps.Map(element, {
            center: new google.maps.LatLng(40.666_85, -73.573_45),
            zoom: 16,
            styles: [
                {
                    featureType: 'poi',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
            ],
        });
        const marker = new google.maps.Marker({
            position: new google.maps.LatLng(40.666_35, -73.572_65),
            map: map,
            title: 'Coleman Country Day Camp',
        });
        const infowindow = new google.maps.InfoWindow({
            content: POPUP_HTML,
        });
        google.maps.event.addListener(marker, 'click', function () {
            infowindow.open(map, marker);
        });
        infowindow.open(map, marker);
    }
}
